<template>
    <div class="page">
        <box>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.query.mtCode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料名称" class="EL-Form-Item">
                        <el-input v-model="mainSearch.query.mtName" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="供应商" class="EL-Form-Item">
                        <el-input v-model="mainSearch.query.vendorCode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="是否启用" class="EL-Form-Item">
                        <el-select v-model="mainSearch.query.sendFlag" clearable="clearable">
                            <el-option label="是" :value="true"></el-option>
                            <el-option label="否" :value="false"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getTableData">查询</el-button>
                        <el-button class="btn-t-delete" @click="resetClick('mainSearch')">重置</el-button>
                    </el-form-item>
                </el-col>
            </el-form>
        </box>
        <box fill>
            <plabel text="寄售管理">
                <el-button class="btn-t-edit" v-authority="'BACK_MENU3_M26_B1'" @click="insertCoamingBox">新增</el-button>
                <el-button class="btn-t-edit" v-authority="'BACK_MENU3_M26_B5'" @click="showCoamingBoxDialog">寄售邮箱</el-button>
                <el-button v-authority="'BACK_MENU3_M26_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <h-table :headerCellStyle="mainData.headerCellStyle" style="flex: 1" @pageChange="getTableData" :data="mainData.data" pagination :nowPage.sync="mainData.nowPage" :pageSize.sync="mainData.pageSize" :total.sync="mainData.total" ref="hTable" @selectionChange="selectAll">
                <el-table-column type="selection" align="center"></el-table-column>
                <el-table-column label="物料编号" align="center" prop="mtCode">
                </el-table-column>
                <el-table-column label="物料名称" align="center" prop="mtName">
                </el-table-column>
                <el-table-column label="供应商" align="center" prop="vendorCode">
                </el-table-column>
                <el-table-column label="最低库存量" align="center" prop="minimumInventory">
                </el-table-column>
                <el-table-column label="是否启用邮箱" align="center" prop="sendFlag">
                    <template slot-scope="scope">
                        <span v-if="scope.row.sendFlag == true">是</span>
                        <span v-if="scope.row.sendFlag == false">否</span>
                    </template>
                </el-table-column>
                 <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU3_M26_B2'" size="mini" type="primary" @click="updateRow(scope.row)" plain icon="el-icon-edit-outline" />
                        <el-button v-authority="'BACK_MENU3_M26_B3'" type="danger" @click="deleteRow(scope.row)" size="mini" plain icon="el-icon-delete" />
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!-- 新增&&编辑框 -->
        <el-dialog :title="add_or_edit ? '新增' : '编辑'" :close-on-click-modal="false" :visible.sync="editBoxShow" :style="$popups.popups(0.5,0.3)" class="fromDialog" :model="mainObj">
            <span class="formClass">
                <el-form label-width="100px" :model="mainObj" :rules="rules" ref="mainObj">
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="物料编号" prop="mtCode" class="EL-Form-Item">
                            <el-select v-model="mainObj.mtCode" placeholder="请选择" filterable clearable="clearable" remote :remote-method="remoteMethodMtCode" @change="changeSysMtName($event)">
                                <el-option v-for="(item, index) in mtCodeList" :key="index" :label="item.mtCode" :value="item.mtCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="物料名称" prop="mtName" class="EL-Form-Item">
                            <el-input v-model="mainObj.mtName" placeholder="请输入" clearable="clearable" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="供应商" prop="svCodeAndName" class="EL-Form-Item">
                            <el-select v-model="mainObj.svCodeAndName" placeholder="请选择" filterable clearable="clearable" remote :remote-method="remoteMethodVendor" @change="changeSysVendor($event)">
                                <el-option v-for="(item, index) in vendorList" :key="index" :label="item.svCode + '-' + item.svName" :value="item.svCode + '-' + item.svName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="最低库存量" prop="minimumInventory" class="EL-Form-Item">
                            <el-input type="number" v-model="mainObj.minimumInventory" onkeypress="return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )"> </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="是否启用邮箱" prop="sendFlag" class="EL-Form-Item">
                            <el-select v-model="mainObj.sendFlag" placeholder="请选择" clearable="clearable">
                                <el-option label="是" :value="true"></el-option>
                                <el-option label="否" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form>
            </span>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button size="small" type="info" @click="closeEditBox">取 消</el-button>
                <el-button size="small" type="primary" v-if="add_or_edit" @click="add">新 增</el-button>
                <el-button size="small" type="primary" v-else @click="editRow">修 改</el-button>
            </span>
        </el-dialog>

        <!-- 包装出入库记录统计 -->
        <el-dialog class="fromDialog" :style="$popups.popups(0.8,0.9)" title="包装出入库统计记录" :visible.sync="coamingBoxDialog" :close="closeProductPullDialog">
            <div style="font-size: 16px">
                <el-form label-position="right" label-width="80px" class="EL-Form">
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="供应商编号" class="EL-Form-Item">
                            <el-input v-model="coamingBoxSearch.vendorCode" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="供应商名称" class="EL-Form-Item">
                            <el-input v-model="coamingBoxSearch.vendorName" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="包装类型" class="EL-Form-Item">
                           <el-select v-model="coamingBoxSearch.boardType" placeholder="请选择" clearable="clearable">
                                <el-option label="底板" value="10"></el-option>
                                <el-option label="围板" value="20"></el-option>
                                <el-option label="盖板" value="30"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="类型" class="EL-Form-Item">
                           <el-select v-model="coamingBoxSearch.type" placeholder="请选择" clearable="clearable">
                                <el-option label="入库" value="10"></el-option>
                                <el-option label="出库" value="20"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="4" :xl="4">
                        <el-form-item class="btn-edit-delete EL-Form-Item">
                            <!-- <el-button class="btn-t-edit" v-authority="'BACK_MENU3_M9_B4'" @click="printProduct()">
                                单据打印
                            </el-button> -->
                            <el-button :loading="downloadChooseLoading" class="btn-t-edit" type="primary" @click="downLoadChooseFile2()" >
                                导出EXCEl
                            </el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="开始日期" class="EL-Form-Item">
                            <el-date-picker v-model="coamingBoxSearch.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="结束日期" class="EL-Form-Item">
                            <el-date-picker v-model="coamingBoxSearch.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    
                </el-form>
                <h-table :headerCellStyle="coamingBoxData.headerCellStyle" :style="$popups.harvestRecordStyle(0.73)" @pageChange="getCoamingBoxStatistics" :data="coamingBoxData.data" pagination :nowPage.sync="coamingBoxData.pageNum" :pageSize.sync="coamingBoxData.pageSize" :total.sync="coamingBoxData.total" @selectionChange="selectAllCoamingBoxData">
                    <el-table-column type="selection" align="center"> </el-table-column>
                    <el-table-column label="供应商编号" prop="vendorCode" align="center">
                    </el-table-column>
                    <el-table-column label="供应商名称" prop="vendorName" align="center">
                    </el-table-column>
                     <el-table-column label="包装类型" align="center" prop="boardType">
                        <template slot-scope="scope">
                            <span v-if="scope.row.boardType == '10'">底板</span>
                            <span v-if="scope.row.boardType == '20'">围板</span>
                            <span v-if="scope.row.boardType == '30'">盖板</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="数量" align="center" prop="matQuan">
                    </el-table-column>
                    <el-table-column label="类型" align="center" prop="type">
                        <template slot-scope="scope">
                            <span v-if="scope.row.type == '10'">入库</span>
                            <span v-if="scope.row.type == '20'">出库</span>
                        </template>
                    </el-table-column>
                </h-table>
            </div>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="closeProductPullDialog()" class="btn-t-info">关 闭</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
export default {
    data(){
        return {
            mainSearch:{
                query:{
                    mtCode: "", //	物理变化
                    mtName: "", //	供应商名称
                    vendorCode: "", //	供应商编号
                    sendFlag: "", //	是否启用邮箱
                    checkFlag: false,
                    saleFlag: true,
                },
            },
            mainData:{
                data: [],
                nowPage: 1,
                pageSize: 20,
                total: 0,
                headerCellStyle: () => {
                    return "background-color: #1f6cec";
                },   
            },
            coamingBoxSearch: {
                vendorCode: "",
                vendorName: "",
                boardType: "",
                type: "",
                date: [],
            },
            coamingBoxData:{
                data: [],
                nowPage: 1,
                pageSize: 20,
                total: 0,
                headerCellStyle: () => {
                    return "background-color: #1f6cec";
                },   
            },
            rules: {
                    svCodeAndName: [{
                        required: true,
                        message: "请选择",
                        trigger: "change",
                    }],
                    boardType: [{
                        required: true,
                        message: "请选择",
                        trigger: "blur",
                    }],
                    matQuan: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    },],
                    type: [{
                        required: true,
                        message: "请选择",
                        trigger: "blur",
                    }, ],
                },
            checkList:[],
            downloadLoading: false, //下载中
            // 输入框延时加载
            isSetTimeout: null,
            returnData:"",

            coamingBoxDialog:false,
            checkCoamingBoxData:[],
            downloadChooseLoading: false,

            //拣配列表窗口
            coamingBoxListShow: false,
            //新增编辑窗口
            editBoxShow:false,
            add_or_edit:false,
            vendorList:[],
            mtCodeList:[],
            mainObj: {
                sendFlag: false,
                saleFlag: true,
                checkFlag: false,
                mtCode: "",
                mtName: "",
                vendorCode: "",
                svCodeAndName: "",
                minimumInventory: "",
            },
            //包装数据
            coamingBoxList:{
                data: [],
                nowPage: 1,
                pageSize: 20,
                total: 0,
                headerCellStyle: () => {
                    return "background-color: #1f6cec";
                },    
            },
            //操作人
            person: localStorage.getItem("user"),
            //操作人工号
            personNumber: localStorage.getItem("empNumber"),
        }
    },
    computed: {
        startPickerOptions() {
            let _this = this;
            return {
                disabledDate(time) {
                    if (_this.mainSearch.query.beginTime) {
                        return time.getTime() > new Date(_this.mainSearch.querybeginTime);
                    }
                },
            };
        },
        finishPickerOptions() {
            let _this = this;
            return {
                disabledDate(time) {
                    if (_this.mainSearch.query.endTime) {
                        return time.getTime() < new Date(_this.mainSearch.query.endTime);
                    }
                },
            };
        },
        pickerOptions() {
            let _this = this
            return {
                disabledDate(time) {
                    if (_this.coamingBoxSearch.date[0]) {
                        return time.getTime() < new Date(_this.coamingBoxSearch.date[0]);
                    }
                }
            }
        },
        pickerOptions0() {
            let _this = this
            return {
                disabledDate(time) {
                    if (_this.coamingBoxSearch.date[1]) {
                        return time.getTime() > new Date(_this.coamingBoxSearch.date[1]);
                    }
                }
            }
        },
    },
    watch:{
        "mainSearch.query":{
           handler() {
            clearTimeout(this.isSetTimeout);
                this.isSetTimeout = setTimeout(() => {
                    this.getTableData();
                }, 1000);
            },
            deep: true,
        },
        coamingBoxSearch: {
            handler(newVal) {
                clearTimeout(this.isSetTimeout)
                this.isSetTimeout = setTimeout(() => {
                    this.getCoamingBoxStatistics(newVal);
            }, 1000);
        },
        deep: true,
    },
    },
    methods:{
        selectAll(val) {
            this.checkList = val;
        },
        selectList(val){
            this.checkListAll = val;
        },
        selectAllCoamingBoxData(val){
            this.checkCoamingBoxData = val;
        },
      
        /* 所有重置按钮的事件 */
        resetClick(type){
            if (type == "mainSearch") {
                this.mainSearch.query = {
                    fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                    mtCode: "", //	物理变化
                    mtName: "", //	供应商名称
                    vendorCode: "", //	供应商编号
                    sendFlag: "", //	是否启用邮箱
                    checkflag: false,
                    saleFlag: true,
                };
                this.mainData.nowPage = 1;
            }
        },
        /* 获取首页数据*/
        getTableData() {
            this.$http
                .request({
                    url: "/api/sysMaterialGroup/getSysMaterialGroupData",
                    method: "GET",
                    params: {
                        pageNum: this.mainData.nowPage, //	页号
                        pageSize: this.mainData.pageSize, //	页大小
                        mtCode: this.mainSearch.query.mtCode || null, //	物料编号
                        mtName: this.mainSearch.query.mtName || null, //	物料名称
                        vendorCode: this.mainSearch.query.vendorCode || null, //	供应商编号
                        sendFlag: this.mainSearch.query.sendFlag || null, //	是否启用邮箱
                        checkflag: this.mainSearch.query.checkFlag || null, 
                        saleFlag: this.mainSearch.query.saleFlag || null,
                    },
                })
                .then((res) => {
                    if (res.status == 100) {
                        this.mainData.data = res.data.list || [];
                        this.mainData.total = res.data.total || 0;
                    } else {
                        this.$message.error("错误");
                    }
                });
        },
        resetMainObj() {
            this.mainObj = {
                sendFlag: false,
                saleFlag: true,
                checkFlag: false,
                mtCode: "",
                mtName: "",
                vendorCode: "",
                svCodeAndName: "",
                minimumInventory: "",
            };
        },
        //打开新增窗口
        insertCoamingBox(){
            this.resetMainObj();
            this.add_or_edit = true;
            this.editBoxShow = true;
            this.$nextTick(() => {
                if (this.$refs.mainObj) {
                    this.$refs.mainObj.clearValidate();
                }
            });
        },
        closeEditBox() {
            this.resetMainObj();
            this.editBoxShow = false;
            this.$nextTick(() => {
                if (this.$refs.mainObj) {
                    this.$refs.mainObj.clearValidate();
                }
            });
        },
        changeSysVendor(svCodeAndName) {
            let vendorInfo = this.vendorList.find((i) => (i.svCode + '-' + i.svName) == svCodeAndName);
            if (vendorInfo) {
                this.mainObj.vendorName = vendorInfo.svName;
                this.mainObj.vendorCode = vendorInfo.svCode;
            }
        },
        changeSysMtName(mtCode) {
            let orderInfo = this.mtCodeList.find((i) => i.mtCode == mtCode);
            this.mainObj.mtName = orderInfo.mtName;
        },
        showCoamingBoxDialog() {
            this.coamingBoxDialog = true;
            this.getCoamingBoxStatistics()
        },
        /**
         * 关闭成品装车窗口
         */
        closeProductPullDialog() {
            this.getTableData();
            this.coamingBoxDialog = false;
        },
        /**
         * 包装出入库统计记录
         */
        getCoamingBoxStatistics: function() {
            if (this.coamingBoxSearch.boardType) {
                var boardType = this.coamingBoxSearch.boardType.join(",");
            }
            this.$http
                .request({
                    url: "/api/coamingBox/getCoamingBoxStatistics",
                    method: "GET",
                    params: {
                        pageNum: this.coamingBoxData.nowPage, //	页号
                        pageSize: this.coamingBoxData.pageSize, //	页大小
                        vendorCode: this.coamingBoxSearch.vendorCode || null, //	供应商编号
                        vendorName: this.coamingBoxSearch.vendorName || null, //	供应商名称
                        type: this.coamingBoxSearch.type || null, //	类型
                        boardType: boardType || null, //	板子类型
                        beginTime: this.coamingBoxSearch.date ?
                            this.coamingBoxSearch.date[0] : null,
                        endTime: this.coamingBoxSearch.date ?
                            this.coamingBoxSearch.date[1] : null,
                    },
                })
                .then((resp) => {
                    if (resp.status == 100) {
                        this.coamingBoxData.data = resp.data.list || [];
                        this.coamingBoxData.total = resp.data.total;
                    }
                })
                .catch((error) => {
                    this.$message({
                        message: "操作失败",
                        type: "warning",
                    });
                });
        },
        /**
         * 远程搜索供应商编号
         */
        remoteMethodVendor(query) {
            if (query !== '') {
                this.loading = true;

                this.mainObj.svCodeAndName = query;
                this.getVendorAll();

                setTimeout(() => {
                    this.loading = false;
                    if (this.vendorList != undefined) {
                        this.vendorList = this.vendorList.filter(item => {
                            return (item.svCode + '-' + item.svName).toLowerCase()
                                .indexOf(query.toLowerCase()) > -1;
                        });
                    }
                }, 200);
            } else {
                this.vendorList = [];
            }
        },
        /**
         * 远程搜索物料编号
         */
        remoteMethodMtCode(query) {
            if (query !== '') {
                this.loading = true;

                this.mainObj.mtCode = query;
                this.getMaterialAll();

                setTimeout(() => {
                    this.loading = false;
                    if (this.mtCodeList != undefined) {
                        this.mtCodeList = this.mtCodeList.filter(item => {
                            return item.mtCode.toLowerCase()
                                .indexOf(query.toLowerCase()) > -1;
                        });
                    }
                }, 200);
            } else {
                this.vendorList = [];
            }
        },
        //获取供应商数据
        getVendorAll() {
            this.$http
                .request({
                    url: "/api/vendor/getVendorAllBySvCodeAndSvName",
                    method: "GET",
                    params: {
                        svCode: this.mainObj.svCodeAndName,
                    },
                })
                .then((resp) => {
                    if (resp.status == 100) {
                        this.vendorList = resp.data.list || [];
                    }
                })
                .catch((error) => {
                    this.loading++;
                });
        },
        //获取物料数据
        getMaterialAll() {
            this.$http
                .request({
                    url: "/api/material/getMaterials",
                    method: "GET",
                    params: {
                        mtCode: this.mainObj.mtCode,
                    },
                })
                .then((resp) => {
                    if (resp.status == 100) {
                        this.mtCodeList = resp.data.list || [];
                    }
                })
                .catch((error) => {
                    this.loading++;
                });
        },
        
        /**
         * 打开修改窗口
         */
        updateRow(row){
            this.mainObj = JSON.parse(JSON.stringify(row));
            this.mainObj.svCodeAndName = row.vendorCode + '-' + row.svName;
            this.mainObj.occupyFlag = row.occupyFlag + "";
            this.add_or_edit = false;
            this.editBoxShow = true;
            this.$nextTick(() => {
                if (this.$refs.mainObj) {
                    this.$refs.mainObj.clearValidate();
                }
            });
        },
        //表单验证
        submitForm(formName) {
            return new Promise((resolve) => {
                this.$refs[formName].validate((valid) => {
                    resolve(valid);
                });
            });
        },
        //新增
        async add() {
            const valid = await this.submitForm("mainObj");
            if (valid) {
                this.$http
                    .request({
                        url: "/api/sysMaterialGroup/insertSysMaterialGroup",
                        method: "POST",
                        showLoading: true,
                        // params:{
                        //     person: this.person,
                        //     personNumber: this.personNumber,
                        // },
                        data: this.mainObj,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$notify({
                                title: "成功",
                                message: "新增成功！",
                                type: "success",
                            });
                            this.logRemarks = "warehouse：寄售新增成功";
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: resp.message,
                            });
                            this.logRemarks = "warehouse：寄售新增失败";
                        }
                        // this.logContent = "prCode" + this.mainObj.prCode;
                        this.systemLog();
                        this.closeEditBox();
                        this.getTableData();
                    })
                    .catch((error) => {
                        this.$notify.error({
                            title: "失败",
                            message: "调用失败",
                        });
                    });
            }
        },
        //编辑
        async editRow() {
            const valid = await this.submitForm("mainObj");
            if (valid) {
                this.$http
                    .request({
                        url: "/api/sysMaterialGroup/updateSysMaterialGroup",
                        method: "POST",
                        showLoading: true,
                        // params:{
                        //     person: this.person,
                        //     personNumber: this.personNumber
                        // },
                        data: this.mainObj,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$notify({
                                title: "成功",
                                message: "修改成功！",
                                type: "success",
                            });
                            this.logRemarks = "warehouse：寄售修改成功";
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: resp.message,
                            });
                            this.logRemarks = "warehouse：寄售修改失败";
                        }
                        // this.logContent = "prCode" + this.mainObj.prCode;
                        this.systemLog();
                        this.closeEditBox();
                        this.getTableData();
                    })
                    .catch((error) => {
                        this.$notify.error({
                            title: "失败",
                            message: "调用失败",
                        });
                    });
            }
        },
            
        //删除
        deleteRow(row) {
            this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                    confirmButtonText: "删除",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    this.$http
                        .request({
                            url: "/api/sysMaterialGroup/deleteSysMaterialGroup",
                            method: "DELETE",
                            showLoading: true,
                            data: row,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "删除成功！",
                                    type: "success",
                                });
                                this.logRemarks = "warehouse：寄售删除成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: "删除失败",
                                });
                                this.logRemarks = "warehouse：寄售删除失败";
                            }
                            // this.logContent = "prId" + prId;
                            this.systemLog();
                            this.getTableData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },

        downLoadChooseFile2() {
            this.downloadChooseLoading = true;
            if (this.coamingBoxSearch.boardType) {
                var boardType = this.coamingBoxSearch.boardType.join(",");
            }
            var paramsObj = {
                vendorCode: this.coamingBoxSearch.vendorCode || null, //	供应商编号
                vendorName: this.coamingBoxSearch.vendorName || null, //	供应商名称
                type: this.coamingBoxSearch.type || null, //	类型
                boardType: boardType || null, //	板子类型
                beginTime: this.coamingBoxSearch.date ?
                    this.coamingBoxSearch.date[0] : null,
                endTime: this.coamingBoxSearch.date ?
                    this.coamingBoxSearch.date[1] : null,
                pageNum: 1,
                pageSize: 999999,
            }
            this.$http.request({
                url: '/api/coamingBox/getCoamingBoxStatistics',
                method: 'GET',
                params: paramsObj
            }).then((resp) => {
                resp.status == 100 ? this.downLoadChoose2(resp.data.list || []) : this.$notify.error({
                    message: '查询失败'
                });
            })
        },

        downLoadChoose2(list) {
            import('@/libs/Export2Excel').then(excel => {
                list.forEach(function(c) {
                    if (c.boardType == '10') {
                        c['boardType'] = '底板'
                    } else if (c.boardType == '20') {
                        c['boardType'] = '围板'
                    } else if (c.boardType == '30') {
                        c['boardType'] = '盖板'
                    }

                    if (c.type == '10') {
                        c['type'] = '入库'
                    } else if (c.type == '20') {
                        c['type'] = '出库'
                    }

                })
                const tHeader = ['供应商编号', '供应商名称', '包装类型', "数量" , '类型']
                    const filterVal = ['vendorCode', 'vendorName', 'boardType', 'matQuan','type']
                const data = this.formatJson(filterVal, list)
                excel.export_json_to_excel({
                    header: tHeader,
                    data,
                    filename: '包装出入库统计记录'
                })
                this.logContent = "导出"
                this.logRemarks = "product_pull：导出包装出入库统计记录"
                this.systemLog();
                this.downloadChooseLoading = false;
            })

        },

        //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                if (this.mainSearch.query.boardType) {
                    var boardType = this.mainSearch.query.boardType.join(",");
                }
                var paramsObj = {
                    vendorCode: this.mainSearch.query.vendorCode || null, //	供应商编号
                    vendorName: this.mainSearch.query.vendorName || null, //	供应商名称
                    type: this.mainSearch.query.type || null, //	类型
                    person: this.mainSearch.query.person || null, //	操作人
                    boardType: boardType || null, //	板子类型
                    beginTime: this.mainSearch.query.beginTime || null,
                    endTime: this.mainSearch.query.endTime || null,
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/coamingBox/getCoamingBoxList',
                    method: 'GET',
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {

                        if (c.boardType == '10') {
                            c['boardType'] = '底板'
                        } else if (c.boardType == '20') {
                            c['boardType'] = '围板'
                        } else if (c.boardType == '30') {
                            c['boardType'] = '盖板'
                        }

                        if (c.type == '10') {
                            c['type'] = '入库'
                        } else if (c.type == '20') {
                            c['type'] = '出库'
                        }

                    })
                    const tHeader = ['供应商编号', '供应商名称', '板子类型', "数量" , '类型', '操作时间', '操作人', '操作人工号']
                    const filterVal = ['vendorCode', 'vendorName', 'boardType', 'matQuan','type', 'createTime', 'userName', 'personNumber']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '包装出入库记录单'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "wh_inventory：导出包装出入库记录单"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "物料状态转换",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        showLoading: true,
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
    },
    activated(){
        this.getVendorAll();
        this.getMaterialAll();
        /* 获取首页的数据 */
        this.getTableData();
    },
}
</script>